<template>
  <customer-profile-description-action-cell
    v-if="isDescription"
    :model="content"
    :review="model"
    @action="reviewAction($event)"
    @removeModel="removeModel()"
  ></customer-profile-description-action-cell>
  <customer-media-confirm-cell
    v-else-if="content"
    :model="content"
    :hideFast="hideFast"
    @action="reviewAction($event)"
    @removeModel="removeModel()"
  ></customer-media-confirm-cell>
  <td v-else></td>
</template>

<script>
import CustomerMediaConfirmCell from "@/components/table/CustomerMediaConfirmCell.vue";
import CustomerProfileDescriptionActionCell from "@/components/table/CustomerProfileDescriptionActionCell.vue";

export default {
  components: {
    CustomerMediaConfirmCell,
    CustomerProfileDescriptionActionCell
  },
  props: ["content", "model", "attribute"],
  computed: {
    isDescription() {
      return this.model.reviewable_type === "App\\CustomerProfile";
    },
    hideFast() {
      return this.attribute.hideFast;
    }
  },
  methods: {
    reviewAction(action) {
      this.$http
        .patch(`/api/v1/customerReview/${this.model.id}`, { action })
        .then(() => this.$emit("table-update"));
    },
    removeModel() {
      this.$emit("removeModel");
    }
  }
};
</script>

<style></style>
